/* eslint-disable no-restricted-syntax */
import {Locale} from '@aboutyou/config';
import {getStaticRoutesByLocale_UNSAFE} from './localizedUrls/getStaticRoutesByLocale';
import {getStaticPagesByLocale_UNSAFE} from './localizedUrls/legal-pages';
import {getRedirectsMap_UNSAFE} from './redirect.paths';
import {getPageTypePathsMap_UNSAFE} from './route.paths';

/**
 * This is marked UNSAFE since this is never intended to be used on the browser bundle.
 * This is intended to be used only on SSR to generate static config
 */
export const getRoutesConfig_UNSAFE = (
  locale: Locale,
  alternateLocales: Array<Locale>,
) => {
  return {
    pageTypePathsMap: getPageTypePathsMap_UNSAFE({locale}),
    redirectsMap: getRedirectsMap_UNSAFE({locale, alternateLocales}),
    staticRoutes: getStaticRoutesByLocale_UNSAFE(locale),
    legalRoutes: getStaticPagesByLocale_UNSAFE(locale),
  };
};
